/**
 * The Watchlists API path.
 */
export const watchlistsAPIPath = "/watchlists";
